.listItem {
  display: flex;
  align-items: center;
  padding: 0;
}

.button {
  padding: 4px;
  margin: 0;
}

.entityAvatar {
  color: var(--tuna-palette-grey-100);
}

.listItemText {
  flex: 1;
  min-width: 0;
}

.primaryText {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.primarySmall {
  font-size: var(--tuna-typography-fontSize-xs);
}

.primaryTiny {
  font-size: var(--tuna-typography-fontSize-2xs);
}

.secondaryText {
  color: var(--tuna-palette-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secondarySmall {
  font-size: var(--tuna-typography-fontSize-2xs);
}

.secondaryTiny {
  font-size: var(--tuna-typography-fontSize-2xs);
}

.secondaryNormal {
  font-size: var(--tuna-typography-fontSize-xs);
}

.listItemAvatar {
  display: flex;
  align-items: center;
}

.listItemAvatarTiny {
  min-width: 4px;
}

.listItemAvatarDefault {
  min-width: 40px;
}
